export const SECTION_TITLE_STYLE = { fontSize: '0.75rem', fontWeight: 600 } as const;
export const BADGE_SMALL_STYLE = { fontSize: '0.7rem' } as const;
export const SECTION_BORDER_STYLE = { borderBottom: '1px solid #dee2e6', paddingBottom: '20px' } as const;

